import { api } from './client';
import type { Page } from './catalogs';


export interface TnnListItem {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  goods_sale_id: string;
  carrier_name: string;
  vehicle_plate: string;
  driver_full_name: string;
  posted: boolean;
  deletion_mark: boolean;
  state: string;
  external_source?: string | null;
}

export interface Tnn extends TnnListItem {
  shipping_address: string | null;
  destination_address: string | null;
  carrier_edrpou: string | null;
  vehicle_model: string | null;
  driver_license_number: string | null;
  cargo_description: string | null;
  total_places: number | null;
  total_weight_kg: string | null;
  posted_at: string | null;
  cancelled_at: string | null;
  cancellation_reason: string | null;
  comment: string | null;
}

export interface TnnCreate {
  organization_id: string;
  document_number?: string | null;
  document_date: string;
  goods_sale_id: string;
  shipping_address?: string | null;
  destination_address?: string | null;
  carrier_name: string;
  carrier_edrpou?: string | null;
  vehicle_plate: string;
  vehicle_model?: string | null;
  driver_full_name: string;
  driver_license_number?: string | null;
  cargo_description?: string | null;
  total_places?: number | null;
  total_weight_kg?: string | null;
  comment?: string | null;
}

export type TnnUpdate = Partial<TnnCreate>;

const PREFIX = '/documents/tnn';

export const tnn = {
  list: (params?: {
    organization_id?: string;
    goods_sale_id?: string;
    posted?: boolean;
    limit?: number;
  }) =>
    api.get<Page<TnnListItem>>(PREFIX, { params }).then((r) => r.data),
  get: (id: string) =>
    api.get<Tnn>(`${PREFIX}/${id}`).then((r) => r.data),
  create: (payload: TnnCreate) =>
    api.post<Tnn>(PREFIX, payload).then((r) => r.data),
  update: (id: string, payload: TnnUpdate) =>
    api.patch<Tnn>(`${PREFIX}/${id}`, payload).then((r) => r.data),
  remove: (id: string) =>
    api.delete(`${PREFIX}/${id}`).then(() => undefined),
  post: (id: string) =>
    api.post<Tnn>(`${PREFIX}/${id}/post`).then((r) => r.data),
  unpost: (id: string) =>
    api.post<Tnn>(`${PREFIX}/${id}/unpost`).then((r) => r.data),
  printUrl: (id: string) => `/api/v1${PREFIX}/${id}/print-view`,
};
